import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SiteVisitComponent } from '../site-visit-detail/site-visit.component';
import { ProposalService } from '../../services/proposal.service';
import { getStoredUser } from '../../helpers/user-storage.util';
import { ToastrService } from 'ngx-toastr';
import { ModalService } from '../../services/modal.service';
import { SiteVisitSendDialogComponent } from '../site-visit-send-dialog/site-visit-send-dialog.component';

@Component({
  selector: 'site-visit-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatFormFieldModule,
    SiteVisitComponent,
    SiteVisitSendDialogComponent,
  ],
  templateUrl: './site-visit-dialog.component.html',
  styleUrl: './site-visit-dialog.component.scss',
})
export class SiteVisitDialogComponent {
  @Input() active: boolean = false;
  @Input() proposal: any;
  @Input() siteDetail: any;
  @Input() siteType: string = '';
  @Input() siteSubType: string = '';
  @Input() address: any = { streetAddress: '', cityStateZip: '' };

  @Output() modalClosed = new EventEmitter<boolean>();
  @Output() updateSiteVisitSiteDetail = new EventEmitter<any>();

  submitButtonDisabled: boolean = false;
  sendSiteVisitDatesActive: boolean = false;

  user = getStoredUser();

  constructor(
    private toastr: ToastrService,
    private proposalService: ProposalService,
    private modalService: ModalService
  ) {}

  ngOnInit() {
    this.determineSubmitButtonEnable();
  }

  toggleSendModal() {
    this.active = false;
    this.modalClosed.emit(false);
    this.sendSiteVisitDatesActive = !this.sendSiteVisitDatesActive;
  }

  submit() {
    this.proposalService
      .submitSiteVisit(this.proposal, this.user.id)
      .subscribe((response: any) => {
        const apiResponse: any = response;
        if (apiResponse.status === 'FAILURE') {
          if (apiResponse.message) {
            this.toastr.error(apiResponse.message);
          } else {
            this.toastr.error('An error occurred. Please try again.');
          }
        } else {
          const updatedSiteDetail = {
            ...this.siteDetail,
            proposal: this.proposal,
          };
          this.siteDetail = updatedSiteDetail;
          this.updateSiteVisitSiteDetail.emit(this.siteDetail);
          this.modalService.toggleOpenSiteVisitConfirmationModal();
        }
      });
  }

  closeDialog() {
    this.active = false;
    this.submitButtonDisabled = true;
    this.proposal = this.siteDetail?.proposal;
    this.modalClosed.emit(false);
  }

  setSiteVisit(event: { updatedProposal: any }) {
    this.proposal = event.updatedProposal;
    this.determineSubmitButtonEnable();
  }

  determineSubmitButtonEnable() {
    if (
      (!this.proposal?.siteVisit1?.date || !this.proposal?.siteVisit1?.slot) &&
      (!this.proposal?.siteVisit2?.date || !this.proposal?.siteVisit2?.slot) &&
      (!this.proposal?.siteVisit3?.date || !this.proposal?.siteVisit3?.slot)
    ) {
      this.submitButtonDisabled = true;
    } else {
      this.submitButtonDisabled = false;
    }
  }
}
